import { Carousel, Divider, Modal, Space } from "antd";
import { useEffect, useRef, useState } from "react";
import { ImagenOptimizada } from "shared-components/Components/Image/web";
import { Favorite } from "shared-components/Components/Property/Favorite/web";
import { FormButton } from "shared-components/Components/Property/InformationRequest/LeadButtons/FormButton/web";
import { CarouselArrow } from "shared-components/Components/Property/LazyImageGallery/CarouselArrow/web";
import { LocationTag } from "shared-components/Components/Property/LocationTag/web";
import { PriceTag } from "shared-components/Components/Property/PriceTag/web";
import { SocialShare } from "shared-components/Components/Property/SocialShare/web";
import { TypologyTag } from "shared-components/Components/Property/TypologyTag/web";
import { useTheme } from "shared-components/Styles/ThemeHook";
import "./styles.less";

export const PropertyModalGallery = ({
	show,
	images,
	img,
	initialIndex,
	onClose,
	listing,
	mode,
}) => {
	const [current, setCurrent] = useState(initialIndex);
	const carouselRef = useRef(null);
	const { theme } = useTheme();

	const settings = {
		dots: false,
		arrows: true,
		accessibility: true,
		swipeToSlide: true,
		nextArrow: <CarouselArrow side={"right"} className="propery-modal-gallery" />,
		prevArrow: <CarouselArrow side={"left"} className="propery-modal-gallery" />,
		infinite: true,
		autoplay: false,
		slidesToScroll: 1,
		slidesToShow: 1,
		speed: 300,
		afterChange: index => setCurrent(index),
		style: {
			height: "100%",
		},
	};

	useEffect(() => {
		const prevAndNext = event => {
			if (show && carouselRef.current && event.code === "ArrowLeft")
				carouselRef.current.prev();
			if (show && carouselRef.current && event.code === "ArrowRight")
				carouselRef.current.next();
		};
		if (show && carouselRef.current && carouselRef.current.goTo) {
			document.addEventListener("keydown", prevAndNext);
			carouselRef.current.goTo(initialIndex);
		}

		return () => {
			document.removeEventListener("keydown", prevAndNext);
		};
	}, [show]);

	return (
		<Modal
			closable
			centered
			visible={show}
			onCancel={onClose}
			width="100vw"
			footer={null}
			className="property-modal-gallery">
			<div className="header-gallery">
				<div className="header-left-gallery">
					<div className="top">
						<PriceTag
							showOperationType={false}
							shortExpensesText={false}
							mode={mode}
							price={listing.price}
							priceVariation={listing.price_variation}
							commonExpenses={listing.commonExpenses}
							temporalCurrency={listing.temporal_currency}
							temporalPrice={listing.temporal_price}
							operationType={listing.operation_type}
							isProject={listing.isProject}
						/>
						<Divider type="vertical" />
						<TypologyTag
							className="property-typology-gallery"
							propertyType={listing.propert}
							operationType={listing.operation_type?.id}
							bedrooms={listing.bedrooms}
							rooms={listing.rooms}
							bathrooms={listing.bathrooms}
							m2={listing.minM2 > 0 ? listing.minM2 : listing.m2}
							hectares={listing.hectares}
							guests={listing.guests}
							loading={false}
						/>
					</div>
					<LocationTag id={listing.id} />
				</div>
				<div className="header-right-gallery">
					<Space size={theme.spacing.mdSpacing}>
						<Favorite id={listing.id} isDisabledProperty={!listing.active} />
						<SocialShare
							id={listing.id}
							mode={mode}
							isDisabledProperty={!listing.active}
						/>
						<FormButton id={listing.id} isDisabledProperty={!listing.active} />
					</Space>
				</div>
			</div>
			<div className="carousel-gallery">
				<Carousel {...settings} ref={carouselRef}>
					{images.length > 0 ? (
						images.map((g, i) => (
							<div className={"carousel-gallery-image"} key={"Gallery_" + i}>
								<ImagenOptimizada src={g.image} alt="Image Photo" />
							</div>
						))
					) : (
						<div className={"carousel-gallery-image"}>
							<ImagenOptimizada src={img} alt="Image Photo" />
						</div>
					)}
				</Carousel>
			</div>
			<div className="pagination-gallery">
				<span>
					{current + 1} / {images.length}
				</span>
			</div>
			<div className="footer-gallery">
				<FormButton id={listing.id} isDisabledProperty={!listing.active} size="large" />
			</div>
		</Modal>
	);
};

